import { render } from "./Gala.vue?vue&type=template&id=40569588&scoped=true"
import script from "./Gala.vue?vue&type=script&lang=js"
export * from "./Gala.vue?vue&type=script&lang=js"

import "./Gala.vue?vue&type=style&index=0&id=40569588&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40569588"]])

export default __exports__